<template>
  <v-app>
    <v-content>
      <v-header v-if="!isLoginRoute"></v-header>
      <div :class="{
             'admin-offset': isAdmin && !isLoginRoute,
             'desktop-menu-offset': isDesktop && !isLoginRoute
           }">
        <router-view></router-view>
      </div>
    </v-content>
    <div class="loaderWrapper" v-if="showLoaderCircular">
      <v-progress-circular
              :size="70"
              :width="7"
              :color="'#89bc41'"
              indeterminate
      ></v-progress-circular>
    </div>
  </v-app>
</template>
<script>

  import vHeader from './components/vHeader'
  import {mapState} from 'vuex';

  export default {
  name: 'App',

  components: {
    vHeader
  },
  computed: {
    ...mapState(['showLoaderCircular', 'isAdmin']),
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    /* $route, not $router.currentRoute: only the former is reactive, so the
       latter evaluates once — before the router has resolved the initial
       navigation — and then never updates. That left the side-menu offset
       applied on the login screen, which has no menu. */
    isLoginRoute() {
      return this.$route.path === '/login';
    },
  },

  data: function (){
    return {
      currentPath: this.$router.currentRoute.path
    }
  },
  created() {
    /* is_admin decides which home screen renders; take it from the server */
    this.$store.dispatch('INIT_SESSION');
  },
};
</script>

<style lang="scss" scoped>
  @import "assets/style.scss";
  /* every screen pads 70px for the fixed app bar; the admin strip adds its own
     28px on top, so content clears both */
  .admin-offset ::v-deep > * {
    padding-top: 98px !important;
  }
  /* Clear the pinned side menu so content never runs underneath it.
     Explicit padding-right: the menu is on the right (Hebrew), and index.html
     has no dir attribute, so logical properties would resolve to the left. */
  .desktop-menu-offset {
    padding-right: 280px;
  }
  .loaderWrapper {
    position: fixed;
    background: rgba(0, 0, 0, 0.46);
    width: 100vw;
    height: 100vh;
    z-index: 9;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
